import React, { useState } from 'react';

interface Props {
	work_description: string;
	maxChars: number;
}

const ReadMoreText = ({ work_description, maxChars }: Props) => {
	const [isExpanded, setIsExpanded] = useState(false);

	const toggleExpansion = () => {
		setIsExpanded(!isExpanded);
	};

	const truncatedText = work_description.slice(0, maxChars);
	const remainingText = work_description.slice(maxChars);

	return (
		<>
			{truncatedText} {isExpanded ? <span>{remainingText}</span> : '...'}
			{!isExpanded ? (
				<span className="decoration-solid underline cursor-pointer pl-[5px] text-[#7777E7]" onClick={toggleExpansion}>
					{' '}
					Read more
				</span>
			) : (
				<span className="decoration-solid underline cursor-pointer pl-[5px] text-[#7777E7]" onClick={toggleExpansion}>
					{' '}
					Read Less
				</span>
			)}
		</>
	);
};

export default ReadMoreText;
